'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (hierarchy, state) {
  return hierarchy.reduce(function (selectorState, currentElem, index) {
    ;[currentElem.el.nodeName].filter(_validationHelpers.tagName).forEach(function (tagName) {
      selectorState.stack[index].splice(0, 0, tagName);
      selectorState.specificity += 10;
    });
    return selectorState;
  }, state);
};

var _validationHelpers = require('./validationHelpers');